export const createSvgElement = <K extends keyof SVGElementTagNameMap>(
  name: K,
  props: Record<string, string> = {}
): SVGElementTagNameMap[K] => {
  const element = window.document.createElementNS(
    'http://www.w3.org/2000/svg',
    name
  );
  Object.entries(props).forEach(([key, value]) =>
    element.setAttribute(key, value)
  );
  return element;
};

export const getJoinedTspanText = (textElement: Element): string =>
  Array.from(textElement.childNodes)
    .filter(node => node.nodeName === 'tspan')
    .map(tspan => tspan?.textContent?.trim())
    .join(' ');
